import { render } from "./ChangeBankForm.vue?vue&type=template&id=a2b18280&scoped=true"
import script from "./ChangeBankForm.vue?vue&type=script&lang=js"
export * from "./ChangeBankForm.vue?vue&type=script&lang=js"

import "./ChangeBankForm.vue?vue&type=style&index=0&id=a2b18280&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b18280"]])

export default __exports__